// constants/color.js
export const COLOR_TARGETS = {
  EXTERIOR_PRIMARY: "EXTERIOR_COLOR_PRIMARY",
  EXTERIOR_SECONDARY: "EXTERIOR_COLOR_SECONDARY",
  INTERIOR_KEY: "INTERIOR_KEY_COLOR",
  INTERIOR_SECONDARY: "INTERIOR_SECONDARY_COLOR",
  INTERIOR_THIRD: "INTERIOR_THIRD_COLOR"
};

export const isInteriorColor = (colorTarget) => {
  return colorTarget?.startsWith('INTERIOR');
};

export const isExteriorColor = (colorTarget) => {
  return colorTarget?.startsWith('EXTERIOR');
};

export const isKeyColor = (colorTarget) => {
  return colorTarget === COLOR_TARGETS.INTERIOR_KEY ||
    colorTarget === COLOR_TARGETS.EXTERIOR_PRIMARY;
};

export const isSecondaryColor = (colorTarget) => {
  return colorTarget === COLOR_TARGETS.INTERIOR_SECONDARY ||
    colorTarget === COLOR_TARGETS.EXTERIOR_SECONDARY;
};

export const COLORWAY_CODES = {
  SINGLE: "SINGLE_COLOR",
  DUAL: "DUAL_COLOR",
  DUAL_WITH_CONSOLE: "DUAL_COLOR_WITH_CONSOLE",
  REAR_HIGHLIGHT: "REAR_SEAT_HIGHLIGHT",
};

// export const COLORWAY_DATA = [
//   {
//     colorwayCode: COLORWAY_CODES.SINGLE,
//     title: "Single Color",
//   },
//   {
//     colorwayCode: COLORWAY_CODES.DUAL,
//     title: "Dual Color",
//   },
//   {
//     colorwayCode: COLORWAY_CODES.DUAL_WITH_CONSOLE,
//     title: "Dual Color with Console",
//   },
//   {
//     colorwayCode: COLORWAY_CODES.REAR_HIGHLIGHT,
//     title: "Rear Seat Highlight",
//   },
// ];
export const COLORWAY_DATA = {
  "SINGLE_COLOR": {
      colorwayCode: COLORWAY_CODES.SINGLE,
      title: "Single Color",
  },
  "DUAL_COLOR": {
      colorwayCode: COLORWAY_CODES.DUAL,
      title: "Dual Color",
  },
  "DUAL_COLOR_WITH_CONSOLE": {
      colorwayCode: COLORWAY_CODES.DUAL_WITH_CONSOLE,
      title: "Dual Color with Console",
  },
  "REAR_SEAT_HIGHLIGHT": {
      colorwayCode: COLORWAY_CODES.REAR_HIGHLIGHT,
      title: "Rear Seat Highlight",
  }
};


export const EXTERIOR_TONE_CODES = {
  SINGLE: "SINGLE_TONE",
  DUAL: "DUAL_TONE",
};

export const EXTERIOR_TONE_DATA = [
  {
    toneCode: EXTERIOR_TONE_CODES.SINGLE,
    title: "Single Tone",
  },
  {
    toneCode: EXTERIOR_TONE_CODES.DUAL,
    title: "Dual Tone",
  },
];


export const COLORWAY_TAB_CONFIG = {
  SINGLE_COLOR: { tabCount: 0 },
  DUAL_COLOR: { tabCount: 2 },
  DUAL_COLOR_WITH_CONSOLE: { tabCount: 2 },
  REAR_SEAT_HIGHLIGHT: { tabCount: 3 },
};
